import React, { useEffect, useState } from "react";
import "./style.css";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import KotButton from "../buttons/KotButton";
import {
  Autocomplete,
  Badge,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  IconButton,
  InputLabel,
  MenuItem,
  Radio,
  Select,
  Switch,
  TextField,
} from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import SettingsIcon from "@mui/icons-material/Settings";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { useDispatch, useSelector } from "react-redux";
import { getAllActiveEmployeesAPICall } from "../../../../../API/Staff/HRM/employeeAPI";
import {
  setAlertMessage,
  setIsLoading,
  setKotOrderStatus,
  setSideMenu,
} from "../../kitchenOrderTicketSlice";
import { NETWORK, listKotOrderStatus } from "../../utils/kotEnum";
import { listKotOrderAPI, updateAllOrderStatus } from "../../kotAPI's";
import DarkModeSwitch from "../switch/DarkMode";
import StyledBadgeDot from "../../../FloorManagement/components/badge/StyledBadge";

import { useNavigate } from "react-router-dom";
import { setHideHeader } from "../../../KotTokenDisplay/kotTokenDisplaySlice";
import { switch_to_billing_screen } from "../../../Sales/Billing/newBillingSlice";
import ConfirmationDialog from "../popUp/statuschange/ConfirmationDialog";

const KotHeader = ({ branchId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { sideMenu, kotOrderStatus, darkMode, networkStatus, kotOrderList } =
    useSelector((state) => state.kitchenOrderTicketSlice);
  const allActiveEmpList = useSelector((state) => state.allActiveEmployeeSlice.value);
  const branchSettingsView = useSelector((state) => state.branchSettingsSliceNew?.rowData);
  const [popup, setPopup] = useState(false);

  const storedPosDevices = (() => {
    try {
      const raw = window?.localStorage?.getItem("branchSettings.posDevices");
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (_e) {
      return [];
    }
  })();

  const posDeviceOptions = Array.isArray(branchSettingsView?.posDevices)
    ? branchSettingsView.posDevices
    : storedPosDevices;

  const VOICE_SETTINGS_KEY = "kotVoiceSettings";
  const getDefaultVoiceSettings = () => ({
    enabled: false,
    soundEnabled: false,
    soundType: "notification",
    voiceGender: "default",
    voiceLanguage: "en",
    voiceSource: "browser", // "browser" = Windows/system TTS, "ai" = StreamElements Neural
    preferredBrowserVoiceURI: "",
    preferredBrowserVoiceName: "",
    aiVoiceId: "",
    staffId: null,
    staffName: "",
    deviceIds: [],
    types: {
      externalApi: true,
      delivery: true,
      dinein: true,
      pickup: true,
    },
  });

  const [voiceSettingsOpen, setVoiceSettingsOpen] = useState(false);
  const [voiceSettings, setVoiceSettings] = useState(getDefaultVoiceSettings());
  const [browserVoices, setBrowserVoices] = useState([]);

  useEffect(() => {
    if (!voiceSettingsOpen) return;
    if (Array.isArray(allActiveEmpList) && allActiveEmpList.length > 0) return;
    getAllActiveEmployeesAPICall();
  }, [voiceSettingsOpen, allActiveEmpList]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(VOICE_SETTINGS_KEY);
      if (raw) {
        const parsed = JSON.parse(raw);
        setVoiceSettings({ ...getDefaultVoiceSettings(), ...parsed, types: { ...getDefaultVoiceSettings().types, ...(parsed?.types || {}) } });
      }
    } catch (e) {
      setVoiceSettings(getDefaultVoiceSettings());
    }
  }, []);

  useEffect(() => {
    if (!voiceSettingsOpen) return;
    if (typeof window === "undefined") return;
    if (!window?.speechSynthesis?.getVoices) return;

    const load = () => {
      try {
        const v = window.speechSynthesis.getVoices() || [];
        setBrowserVoices(Array.isArray(v) ? v : []);
      } catch (_e) {
        setBrowserVoices([]);
      }
    };

    load();
    window.speechSynthesis.onvoiceschanged = load;
    return () => {
      if (window?.speechSynthesis) window.speechSynthesis.onvoiceschanged = null;
    };
  }, [voiceSettingsOpen]);

  const saveVoiceSettings = () => {
    localStorage.setItem(VOICE_SETTINGS_KEY, JSON.stringify(voiceSettings));
    window.dispatchEvent(new Event("kotVoiceSettingsChanged"));
    setVoiceSettingsOpen(false);
  };

  const previewVoice = () => {
    window.dispatchEvent(new CustomEvent("kotVoicePreview", { detail: { ...voiceSettings, previewType: "voice" } }));
  };

  const previewSound = () => {
    window.dispatchEvent(new CustomEvent("kotVoicePreview", { detail: { ...voiceSettings, previewType: "sound" } }));
  };
  const buttons = [
    { name: "All", color: "#cc009c", key: listKotOrderStatus.ALL },
    { name: "NEW", color: "#8406cc", key: listKotOrderStatus.NEW },
    { name: "PREPARING", color: "#1e05cc", key: listKotOrderStatus.PREPARING },
    { name: "COMPLETED", color: "#0569cc", key: listKotOrderStatus.COMPLETED },
  ];

  // button handle change
  const handleHeaderBtnChange = (index, data) => {
    dispatch(setAlertMessage(null));
    dispatch(setIsLoading(true));
    const ids = Array.isArray(voiceSettings?.deviceIds) ? voiceSettings.deviceIds : [];
    let body = {
      branchId,
      status: data?.key,
      deviceIds: ids.length > 0 ? ids : undefined,
    };
    dispatch(setKotOrderStatus({ status: data, index: index }));
    // api call for list  of orders based on status
    listKotOrderAPI({ body });
  };

  //on filter button click
  const filterBtnClicked = () => {
    dispatch(setSideMenu(!sideMenu));
  };

  // select all action
  const handleChangeAllItemStatus = () => {
    const body = {
      branchId,
      idList: kotOrderList.map((item) => item._id),
    };
    updateAllOrderStatus({ body, setPopup, index: kotOrderStatus.index });
  };
  const onPopupClose = () => {
    setPopup(false);
  };

  return (
    <div className="kot-header-container">
      <div className="kot-header">
        <div className="kot-header-left-side">
          <Badge color="secondary" variant="dot" invisible={false}>
            <button onClick={() => filterBtnClicked()} className="kot-filter">
              <FilterAltIcon sx={{ color: darkMode ? "white" : "black" }} />
            </button>
          </Badge>

          <IconButton
            onClick={() => setVoiceSettingsOpen(true)}
            size="small"
            sx={{ border: "1px solid var(--border)", borderRadius: 0, width: 35, height: 35 }}
          >
            <SettingsIcon sx={{ color: darkMode ? "white" : "black" }} />
          </IconButton>

          {kotOrderStatus.index !== 0 && kotOrderList?.length > 0 && (
            <Button
              onClick={() => setPopup(true)}
              color="error"
              variant="outlined"
            >{`${
              kotOrderStatus.index == 1
                ? "cook"
                : kotOrderStatus.index == 2
                ? "complete"
                : kotOrderStatus.index == 3
                ? "delivery"
                : ""
            } all`}</Button>
          )}
        </div>
        <div className="kot-action-button">
          {buttons?.map((btn, index) => (
            <div
              className={`kot-action-item`}
              key={index}
              style={{
                borderBottom:
                  kotOrderStatus?.index === index
                    ? `5px solid ${btn.color}`
                    : "",
              }}
            >
              <KotButton
                active={kotOrderStatus?.index === index}
                index={index}
                onClick={() => handleHeaderBtnChange(index, btn)}
                name={btn?.name}
                color={btn?.color}
              />
            </div>
          ))}
        </div>
        <div className="kot-action-container">
          <StyledBadgeDot
            animate={networkStatus === NETWORK.ONLINE ? false : true}
            isActive={true}
            ActiveColor={
              networkStatus === NETWORK.ONLINE ? "#4bbda6" : "#fa1b49"
            }
          />
          <span className="network-status">
            {networkStatus === NETWORK.ONLINE ? "Online" : "Offline"}
          </span>

          <DarkModeSwitch />
          <div>
            <button
              className="close-icon-btn"
              onClick={() => {
                dispatch(switch_to_billing_screen({ billingBoolean: false }));
                navigate("/userdashboard/dashboardhome");
                dispatch(setHideHeader(false));
              }}
            >
              <HighlightOffIcon color="error" />
            </button>
          </div>
        </div>
      </div>
      <ConfirmationDialog
        open={popup}
        onClose={onPopupClose}
        onConfirm={handleChangeAllItemStatus}
      />

      <Dialog open={voiceSettingsOpen} onClose={() => setVoiceSettingsOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>AI Voice Settings</DialogTitle>
        <DialogContent>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 8 }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span style={{ fontWeight: 600 }}>Enable Voice</span>
              {voiceSettings?.enabled === true && (
                <IconButton size="small" onClick={previewVoice} title="Preview Voice">
                  <PlayArrowIcon fontSize="small" />
                </IconButton>
              )}
            </div>
            <Switch
              checked={voiceSettings?.enabled === true}
              onChange={(e) => setVoiceSettings((p) => ({ ...p, enabled: e.target.checked }))}
            />
          </div>

          {voiceSettings?.enabled === true && (
            <div style={{ marginTop: 10 }}>
              <FormControl fullWidth size="small">
                <InputLabel id="kot-voice-gender-label">Voice Type</InputLabel>
                <Select
                  labelId="kot-voice-gender-label"
                  value={voiceSettings?.voiceGender || "default"}
                  label="Voice Type"
                  onChange={(e) => setVoiceSettings((p) => ({ ...p, voiceGender: e.target.value }))}
                >
                  <MenuItem value="default">Default</MenuItem>
                  <MenuItem value="male">Male</MenuItem>
                  <MenuItem value="female">Female</MenuItem>
                </Select>
              </FormControl>

              <div style={{ marginTop: 10 }}>
                <FormControl fullWidth size="small">
                  <InputLabel id="kot-voice-language-label">Language</InputLabel>
                  <Select
                    labelId="kot-voice-language-label"
                    value={voiceSettings?.voiceLanguage || "en"}
                    label="Language"
                    onChange={(e) => setVoiceSettings((p) => ({ ...p, voiceLanguage: e.target.value }))}
                  >
                    <MenuItem value="en">English</MenuItem>
                    <MenuItem value="ar">Arabic</MenuItem>
                    <MenuItem value="hi">Hindi</MenuItem>
                    <MenuItem value="ml">Malayalam</MenuItem>
                    <MenuItem value="fr">French</MenuItem>
                    <MenuItem value="zh">Chinese</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>
          )}

          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 8 }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span style={{ fontWeight: 600 }}>Enable Sound</span>
              {voiceSettings?.soundEnabled === true && (
                <IconButton size="small" onClick={previewSound} title="Preview Sound">
                  <PlayArrowIcon fontSize="small" />
                </IconButton>
              )}
            </div>
            <Switch
              checked={voiceSettings?.soundEnabled === true}
              onChange={(e) => setVoiceSettings((p) => ({ ...p, soundEnabled: e.target.checked }))}
            />
          </div>

          {voiceSettings?.soundEnabled === true && (
            <div style={{ marginTop: 10 }}>
              <FormControl fullWidth size="small">
                <InputLabel id="kot-sound-type-label">Sound</InputLabel>
                <Select
                  labelId="kot-sound-type-label"
                  value={voiceSettings?.soundType || "notification"}
                  label="Sound"
                  onChange={(e) => setVoiceSettings((p) => ({ ...p, soundType: e.target.value }))}
                >
                  <MenuItem value="notification">Notification</MenuItem>
                  <MenuItem value="alarm">Alarm</MenuItem>
                  <MenuItem value="chime">Chime</MenuItem>
                  <MenuItem value="bass_drop">Bass Drop</MenuItem>
                  <MenuItem value="bass_pulse">Bass Pulse</MenuItem>
                  <MenuItem value="deep_chime">Deep Chime</MenuItem>
                  <MenuItem value="sonar">Sonar</MenuItem>
                  <MenuItem value="double_knock">Double Knock</MenuItem>
                  <MenuItem value="techno">Techno</MenuItem>
                  <MenuItem value="drum_hit">Drum Hit</MenuItem>
                  <MenuItem value="bell">Bell</MenuItem>
                  <MenuItem value="siren_soft">Siren Soft</MenuItem>
                  <MenuItem value="bass_alarm">Bass Alarm</MenuItem>
                </Select>
              </FormControl>
            </div>
          )}

          {/* Voice Source Selection */}
          <div style={{ marginTop: 12, paddingTop: 8, borderTop: "1px solid #e0e0e0" }}>
            <span style={{ fontWeight: 600, display: "block", marginBottom: 8 }}>Voice Source</span>
            <FormControl fullWidth size="small">
              <Select
                value={voiceSettings?.voiceSource || "browser"}
                onChange={(e) => setVoiceSettings((p) => ({ ...p, voiceSource: e.target.value }))}
              >
                <MenuItem value="browser">Browser/System Voice (Windows TTS)</MenuItem>
                <MenuItem value="ai">AI Voice (StreamElements Neural)</MenuItem>
              </Select>
            </FormControl>
            <span style={{ fontSize: "10px", color: "#666", marginTop: 4, display: "block" }}>
              {voiceSettings?.voiceSource === "ai" 
                ? "Uses online neural voices - requires internet"
                : "Uses voices installed on your Windows/browser - works offline"}
            </span>
          </div>

          {voiceSettings?.voiceSource === "browser" && (
            <div style={{ marginTop: 10 }}>
              <FormControl fullWidth size="small">
                <InputLabel id="kot-browser-voice-label">Browser Voice</InputLabel>
                <Select
                  labelId="kot-browser-voice-label"
                  label="Browser Voice"
                  value={voiceSettings?.preferredBrowserVoiceURI || ""}
                  onChange={(e) => {
                    const uri = e.target.value || "";
                    const v = Array.isArray(browserVoices) ? browserVoices.find((x) => String(x?.voiceURI) === String(uri)) : null;
                    setVoiceSettings((p) => ({
                      ...p,
                      preferredBrowserVoiceURI: uri,
                      preferredBrowserVoiceName: v?.name || "",
                    }));
                  }}
                >
                  <MenuItem value="">Auto (Best match)</MenuItem>
                  {(Array.isArray(browserVoices) ? browserVoices : []).map((v) => (
                    <MenuItem key={String(v?.voiceURI || v?.name)} value={String(v?.voiceURI || "")}>
                      {(v?.name || "Unnamed")} ({(v?.lang || "").toString() || "?"})
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          )}

          {voiceSettings?.voiceSource === "ai" && (
            <div style={{ marginTop: 10 }}>
              <TextField
                fullWidth
                size="small"
                label="AI Voice ID (Optional)"
                value={voiceSettings?.aiVoiceId || ""}
                onChange={(e) => setVoiceSettings((p) => ({ ...p, aiVoiceId: e.target.value }))}
                placeholder="Example: ar-SA-ZariyahNeural"
                helperText="Leave empty to use automatic male/female mapping"
              />
            </div>
          )}

          <div style={{ marginTop: 10, display: "grid", gridTemplateColumns: "1fr 1fr", gap: "6px" }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={voiceSettings?.types?.externalApi === true}
                  onChange={(e) =>
                    setVoiceSettings((p) => ({
                      ...p,
                      types: { ...p.types, externalApi: e.target.checked },
                    }))
                  }
                />
              }
              label="External API"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={voiceSettings?.types?.delivery === true}
                  onChange={(e) =>
                    setVoiceSettings((p) => ({
                      ...p,
                      types: { ...p.types, delivery: e.target.checked },
                    }))
                  }
                />
              }
              label="Delivery"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={voiceSettings?.types?.dinein === true}
                  onChange={(e) =>
                    setVoiceSettings((p) => ({
                      ...p,
                      types: { ...p.types, dinein: e.target.checked },
                    }))
                  }
                />
              }
              label="Dinein"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={voiceSettings?.types?.pickup === true}
                  onChange={(e) =>
                    setVoiceSettings((p) => ({
                      ...p,
                      types: { ...p.types, pickup: e.target.checked },
                    }))
                  }
                />
              }
              label="Pickup"
            />
          </div>

          <div style={{ marginTop: 10 }}>
            <Autocomplete
              freeSolo
              options={Array.isArray(allActiveEmpList) ? allActiveEmpList : []}
              getOptionLabel={(option) => {
                if (typeof option === "string") return option;
                return option?.staff_name || "";
              }}
              value={
                voiceSettings?.staffId
                  ? (Array.isArray(allActiveEmpList)
                      ? allActiveEmpList.find((e) => e?._id === voiceSettings.staffId) || voiceSettings?.staffName || ""
                      : voiceSettings?.staffName || "")
                  : voiceSettings?.staffName || ""
              }
              onChange={(_e, newValue) => {
                if (typeof newValue === "string") {
                  setVoiceSettings((p) => ({ ...p, staffId: null, staffName: newValue }));
                  return;
                }
                setVoiceSettings((p) => ({
                  ...p,
                  staffId: newValue?._id || null,
                  staffName: newValue?.staff_name || "",
                }));
              }}
              onInputChange={(_e, newInputValue) => {
                setVoiceSettings((p) => ({ ...p, staffId: null, staffName: newInputValue }));
              }}
              renderInput={(params) => (
                <TextField {...params} fullWidth size="small" label="Chef / Staff Name" />
              )}
            />
          </div>

          <div style={{ marginTop: 10 }}>
            <Autocomplete
              multiple
              disableCloseOnSelect
              options={posDeviceOptions}
              isOptionEqualToValue={(option, value) => String(option?._id) === String(value?._id)}
              getOptionLabel={(option) => option?.deviceName || option?.name || ""}
              value={
                Array.isArray(voiceSettings?.deviceIds) && voiceSettings.deviceIds.length > 0
                  ? (Array.isArray(posDeviceOptions)
                      ? posDeviceOptions.filter((d) => voiceSettings.deviceIds.includes(String(d?._id)))
                      : [])
                  : []
              }
              onChange={(_e, newValue) => {
                const ids = Array.isArray(newValue) ? newValue.map((d) => String(d?._id)).filter(Boolean) : [];
                setVoiceSettings((p) => ({ ...p, deviceIds: ids }));
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  size="small"
                  label="Device Filter (POS Devices)"
                  placeholder="Select devices"
                />
              )}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setVoiceSettingsOpen(false)} color="inherit">Cancel</Button>
          <Button onClick={saveVoiceSettings} variant="contained">Save</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default KotHeader;
